export default class AlertPopup extends PIXI.Container {
	constructor() {
		super();

		this._icon = new PIXI.Sprite(PIXI.Texture.EMPTY);
		this._icon.anchor.set(0.5);
		this._icon.visible = false;
		this.addChild(this._icon);

		this._tweens = new TWEEN.Group();
	}

	update() {
		this._tweens.update();
	}

	destroy() {
		this._tweens.removeAll();

		super.destroy({ children: true });
	}

	start(type = AlertPopup.TYPE_SURVIVE) {
		switch (type) {
		default :
		case AlertPopup.TYPE_SURVIVE : {
			this._icon.texture = P3.assets.texture('alert_survive');
			break;
		}
		case AlertPopup.TYPE_INJURED : {
			this._icon.texture = P3.assets.texture('alert_injured');
			break;
		}
		case AlertPopup.TYPE_CRITICAL : {
			this._icon.texture = P3.assets.texture('alert_critical');
			break;
		}
		case AlertPopup.TYPE_DEAD : {
			this._icon.texture = P3.assets.texture('alert_dead');
			break;
		}
		}

		this._tweens.removeAll();
		const up = new TWEEN.Tween(this._icon, this._tweens)
			.to({ y: -40 }, 320)
			.easing(TWEEN.Easing.Quadratic.Out)
			.onStart(() => {
				this._icon.alpha = 1;
				this._icon.visible = true;
			});

		const down = new TWEEN.Tween(this._icon, this._tweens)
			.to({ y: 0 }, 400)
			.easing(TWEEN.Easing.Quadratic.In);

		const fade = new TWEEN.Tween(this._icon, this._tweens)
			.to({ alpha: 0 }, 800)
			.easing(TWEEN.Easing.Quadratic.InOut)
			.delay(440)
			.onComplete(() => {
				this._icon.visible = false;
			});

		down.chain(fade);
		up.chain(down).start();
	}

	get tweens() {
		return this._tweens;
	}
}

AlertPopup.TYPE_SURVIVE = 0;
AlertPopup.TYPE_INJURED = 1;
AlertPopup.TYPE_CRITICAL = 2;
AlertPopup.TYPE_DEAD = 3;
